import React from 'react';
import { Button, Card, Collection, Divider, Flex, Image, Text, useAuthenticator, View } from '@aws-amplify/ui-react';
import { Navigate, useNavigate } from 'react-router-dom';
import { s3ListObjects, s3ReadFile, s3WriteFile, s3DeleteFile } from '../components/s3Utils';
import { verifiedUser, istMitarbeiter } from '../components/utils';

const handleListObjects = () => {
  // 'public', 'private'
  //  s3ListObjects('', 'public')
  s3ListObjects('', 'private', null)
}


const handleWriteFile = () => {
  // 'private' only
  s3WriteFile("test.txt", "Protected Content")
}

const handleDeleteFile = () => {
  // 'private' only
  s3DeleteFile("test.txt")
}

const Home = (props) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const showButtons = false;
  const navigate = useNavigate();
  //  const usePatSpeiseplanEdit = false;

  const handleReadFile = () => {
    // 'public', 'private'
    s3ReadFile('menueliste.txt', 'public', null)
  }

  const items = istMitarbeiter(user) ? [
    {
      title: 'Menüwahl',
      name: 'menues',
      navTo: "/menues",
      pict: require('../components/assets/Mittagessen.jpg'),
      alt: 'Hier können Sie Ihr Mittagessen für die nächsten Tage wählen.',
    },
    {
      title: 'Information',
      name: 'information',
      navTo: '/information',
      pict: require('../components/assets/Information.jpg'),
      alt: 'Informationen zum Herunterladen',
    },
    {
      title: 'Profil',
      name: 'profile',
      navTo: '/profile',
      pict: require('../components/assets/Profil.jpg'),
      alt: 'Ihr Profil',
    },

  ] :
    [
      {
        title: 'Anamnesebogen',
        name: 'anamnese',
        navTo: '/anamnese',
        pict: require('../components/assets/Anamnese.jpg'),
        alt: 'Bitte füllen Sie hier Ihren Anamnesebogen aus.',
      },
      {
        title: 'Rehaziele',
        name: 'rehaziele',
        navTo: '/rehaziele',
        pict: require('../components/assets/Rehaziele.jpg'),
        alt: 'Bitte füllen Sie hier Ihre Rehaziele aus.',
      },
      {
        title: 'Würzburger Screening',
        name: 'screening',
        navTo: '/screening',
        pict: require('../components/assets/Screening.jpg'),
        alt: 'Berufstätige füllen bitte hier das Würzburger Screening aus.',
      },
      {
        title: 'Einverständniserklärungen',
        name: 'einverstaendnis',
        navTo: '/einverstaendnis',
        pict: require('../components/assets/Einverstaendnis.jpg'),
        alt: 'Bitte füllen Sie hier Ihre Einverständniserklärungen aus.',
      },
      {
        title: 'Menüwahl',
        name: 'menues',
        navTo: "/menues",
        pict: require('../components/assets/Mittagessen.jpg'),
        alt: 'Hier können Sie Ihr Mittagessen für die nächsten Tage wählen.',
      },
      {
        title: 'Informationen',
        name: 'information',
        navTo: '/information',
        pict: require('../components/assets/Information.jpg'),
        alt: 'Hier finden Sie Informationen zum Herunterladen.',
      },
      {
        title: 'Profil',
        name: 'profile',
        navTo: '/profile',
        pict: require('../components/assets/Profil.jpg'),
        alt: 'Hier können Sie Ihr Profil bearbeiten und löschen.',
      },
    ]

  return (
    <>
      <View height="4rem"></View>
      <Flex
        justifyContent="space-around"
      >
        {verifiedUser(user) ?
          <>
            <Collection
              items={items}
              type="list"
              direction="row"
              gap="50px"
              justifyContent="space-around"
              wrap="wrap"
            >
              {(item, index) => (
                <Card
                  key={index}
                  borderRadius="medium"
                  minWidth="15rem"
                  maxWidth="20rem"
                  variation="outlined"
                  boxShadow="2px 2px 3px 4px var(--amplify-colors-neutral-60)"

                >
                  <Flex
                    direction="column"
                    alignItems="center"
                  >

                    <Image
                      src={item.pict}
                      alt={item.alt}
                      height="18rem"
                      width="18"
                    />
                    <Divider padding="xs" />
                    <View height='5rem' textAlign="center">
                      <Text padding="medium" >{item.alt}</Text>
                    </View>
                    <Button
                      size="large"
                      variation="primary"
                      name={item.name}
                      onClick={() => navigate(`${item.navTo}`)}
                      isFullWidth
                    >{item.title}</Button>
                  </Flex>
                </Card>
              )}
            </Collection>
          </> : <Navigate to='/profile' replace={true} />
        }
        {showButtons && <>

          <Button onClick={handleListObjects}>List S3</Button>
          <Button onClick={handleReadFile}>Daten holen</Button>
          <Button onClick={handleWriteFile}>Daten schreiben</Button>
          <Button onClick={handleDeleteFile}>Daten löschen</Button>
        </>
        }
      </Flex>
      <View height="4rem" />
    </>
  )
}

export default Home;